import React, { Component } from "react";
import "./App.css";
import Section from "./components/Section";
import Backdrop from "./components/Backdrop";
import castillo from "./castillo.svg"
import ReactDOM from "react-dom";

function calculateSize(innerWidth) {
  let newWidth = innerWidth / 1024;
  return newWidth > 1 ? 1 : newWidth < 0.7 ? 0.7 : newWidth;
}

const nativeData = [
  {
    skill: "Swift",
    level: 0.8,
    color: "#F88370"
  },
  {
    skill: "Obj-C",
    level: 0.5,
    color: "#C4769E"
  },
  {
    skill: "C",
    level: 0.4,
    color: "#617A9F"
  },
  {
    skill: "C#",
    level: 0.6,
    color: "#0F6F6C"
  }
];

const webData = [
  {
    skill: "React",
    level: 0.8,
    color: "#9FE885"
  },
  {
    skill: "Elm",
    level: 0.5,
    color: "#54D0A7"
  },
  {
    skill: "Hyperapp",
    level: 0.7,
    color: "#42B1BA"
  },
  {
    skill: "Node.js",
    level: 0.9,
    color: "#6A8DB0"
  },
  {
    skill: "SASS/LESS",
    level: 0.8,
    color: "#85688C"
  },
  {
    skill: "Three.js",
    level: 0.5,
    color: "#83495C"
  },
  {
    skill: "Liquid",
    level: 0.8,
    color: "#6A3631"
  },

];

const visData = [
  {
    skill: "D3.js",
    level: 0.7,
    color: "#356A81"
  },
  {
    skill: "p5.js",
    level: 0.5,
    color: "#168D8A"
  },
  {
    skill: "ArcGIS",
    level: 0.6,
    color: "#45AD7C"
  },
  {
    skill: "Unity",
    level: 0.8,
    color: "#92C763"
  },
  {
    skill: "Cinder",
    level: 0.3,
    color: "#ECD754"
  },
];

class App extends Component {
  state = {
    fontSize: calculateSize(window.innerWidth),
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    scrollY: window.scrollY
  };

  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
    this.ticking = false;
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowInfo);
    window.addEventListener("scroll", this.updateWindowInfo);
    this.updateWindowInfo()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowInfo);
    window.removeEventListener("scroll", this.updateWindowInfo);
  }

  updateWindowInfo = event => {
    this.setState({
      fontSize: calculateSize(window.innerWidth),
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      scrollY: window.scrollY
    });
  };

  render() {
    return (
      <div style={{ fontSize: `${this.state.fontSize * 100}%` }}>
        <header className={`${this.state.scrollY > 200 ? `fadeOut` : ``}`}>
          <Backdrop/>
        </header>
        <a className={`scroll ${this.state.scrollY > 200 ? `fadeOut` : ``}`} onClick={() => {
          ReactDOM.findDOMNode(this.sectionRef.current).scrollIntoView({ behavior: 'smooth', block: 'center' })
        }}>
          <svg aria-hidden="true" data-prefix="fas" role="img" xmlns="http://www.w3.org/2000/svg" height="64" width="64" viewBox="0 0 448 512"><path fill="currentColor" d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"></path></svg>
        </a>
        <div className="blank" />
        <Section title="Summary" ref={this.sectionRef}>
          <p>
            My name is{" "}
            <a href="https://www.linkedin.com/in/dylanrw">
              Dylan Wreggelsworth
            </a>
            <sup>
              [<a href="#0">0</a>]
            </sup>. I'm an independent designer, developer, advisor, and consultant.
          </p>
          <p>
            I am interested in{" "}
            <a href="http://dyli.sh/2013/04/20/Oblivion-Interactions-and-Aesthetic.html">
              sci-fi
            </a>, <a href="https://bvr.design/">aviation</a>, <a href="http://gameofcyvasse.com">game design</a>,
            military history, fine art,{" "}
            <a href="https://soundcloud.com/dylanrw/sets/retrowave">music</a>
            <sup>
              [<a href="#1">1</a>]
            </sup>,{" "}
            <a href="https://dribbble.com/shots/1454268-80s-TV-Cube-Final">
              motion graphics
            </a>
            <sup>
              [<a href="#2">2</a>]
            </sup>, 3D design,{" "}
            <a href="https://dribbble.com/shots/44896-Naval-Battle">
              pixel art
            </a>
            <sup>
              [<a href="#3">3</a>]
            </sup>,{" "}
            <a href="https://github.com/dylan/swift-game-programming-patterns">
              programming
            </a>
            <sup>
              [<a href="#4">4</a>]
            </sup>, and{" "}
            <a href="https://twitter.com/dylanrw/status/388072124381790208">
              long boarding
            </a>
            <sup>
              [<a href="#4">4</a>]
            </sup>.
          </p>
          <p>
            I think{" "}
            <a href="http://www.imdb.com/title/tt0083658/">Blade Runner</a> is
            cool.
          </p>
          <p>
            I still have a{" "}
            <a href="https://twitter.com/dylanrw/status/285682134142824448">
              Commodore 64
            </a>
            <sup>
              [<a href="#5">5</a>]
            </sup>.
          </p>
        </Section>

        <Section title="Services">
          <p>My work has been seen in Apple commercials, FCC hearings, and on desktop software the world over. UI/UX Design, and Icon Illustration are where I got my start, but the most interesting design problems are not constrained to a particular medium or discipline. I've helped people define their initial product as well as design and build it.</p>
          <h4>Group?</h4>
          <p>If a given job requires more, I have a broad talent network of specialists I've worked with for years we can pull in. This has happened so often over the years, that I adopted the name BVR Group in 2008.</p>
        </Section>

        <Section title="Native" radarName="Language Proficiency" radarData={nativeData}>
          <p>Swift has made iOS and macOS development a pleasure. I have experience developing UIKit oriented apps, audio related apps, macOS tool design, and game developement.</p>
        </Section>

        <Section title="Web" radarName="Frameworks & Libraries" radarData={webData}>
          <p>The majority of my work over the years has been web-centric. From marketing oriented projects to full featured products.</p>
        </Section>

        <Section title="Data Visualization" radarName="Tools" radarData={visData}>
          <p>Pitch decks, census reports, dashboards, data driven VFX. Good design can bring clarity to a project.</p>
        </Section>
        <Section title="Travel">
          <p>In the past I lived in Mountain View, CA and did a lot of local consultation. Eventually the majority of my contracts did not require being local, and I moved to the east coast and continued to encourage this remote-working trend. Though I prefer to work remotely, for the right projects, I can travel to meet and work with you in person.</p>
        </Section>
        <Section title="Hire Me">
          <p>I've worked for fortune 500 companies, agencies, boutiques, a myriad of startups, and as an independent consultant. If your project is a good fit I'm available for short or long term consultation.</p>
          <p><a href="mailto: info(at)bvr.group">Contact me.</a></p>
        </Section>
        <Section title="Links">
          <ol start="0">
            <li>
              <a id="0" href="http://linkedin.com/in/dylanrw">
                LinkedIn
                </a>
            </li>
            <li>
              <a id="1" href="https://soundcloud.com/dylanrw">
                Soundcloud
              </a>
            </li>
            <li>
              <a id="2" href="https://dribbble.com/dylanrw">
                Dribbble
                </a>
            </li>
            <li>
              <a id="3" href="https://github.com/dylan">
                GitHub
                </a>
            </li>
            <li>
              <a id="4" href="https://twitter.com/dylanrw">
                Twitter
                </a>
            </li>
          </ol>
        </Section>
        <footer>
          <p>
            Copyright &copy;<br/>
            <strong>Beyond Visual Range</strong>
          </p>
          <p></p>
          <p className='madeIn'>
            <img src={castillo} alt="Castillo De San Marcos"  />
            <span>Made in<br/><a href="https://www.atlasobscura.com/things-to-do/st-augustine-florida"><strong>Saint Augustine, FL</strong></a></span>
          </p>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js